import * as fb from '@/firebase';

export class InviteCode {
  public static empty() {
    const inviteCode = new InviteCode();
    inviteCode.creator = null;
    inviteCode.code = '';
    inviteCode.description = '';
    inviteCode.priorCodes = [];
    inviteCode.maxUses =
    inviteCode.numUsed = 0;
    inviteCode.id = '';
    inviteCode.lastUpdatedBy = '';
    inviteCode.timeLastUpdated = new Date();
    return inviteCode;
  }

  public static fromFirebaseDoc(
    id: string,
    doc: firebase.firestore.DocumentData
  ): InviteCode {
    const inviteCode = new InviteCode();
    inviteCode.creator = doc.creator;
    inviteCode.code = doc.code;
    inviteCode.description = doc.description;
    inviteCode.priorCodes = doc.priorCodes as string[];
    inviteCode.maxUses = doc.maxUses as number;
    inviteCode.numUsed = doc.numUsed as number;
    inviteCode.timeLastUpdated = new Date((doc.timeLastUpdated as number) || 0);
    inviteCode.lastUpdatedBy = doc.lastUpdatedBy;
    inviteCode.id = id;
    return inviteCode;
  }

  public creator: string;
  public code: string;
  public description: string;
  public priorCodes: string[];
  public maxUses: number;
  public numUsed: number;
  public id: string;
  public timeLastUpdated: Date;
  public lastUpdatedBy: string;

  public toFirebaseDoc(): any {
    return {
      creator: this.creator,
      code: this.code,
      description: this.description,
      priorCodes: this.priorCodes,
      maxUses: this.maxUses,
      numUsed: this.numUsed,
      timeLastUpdated: this.timeLastUpdated.getTime(),
      lastUpdatedBy: this.lastUpdatedBy
    };
  }
}